import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { useLiveQuery } from 'dexie-react-hooks';
import { esDeudaAnterior } from '@abastece/core';
import { db } from '../db/dexie.js';
import { usePuede } from '../lib/sesion.js';
import { FormularioProveedor } from '../ui/FormularioProveedor.js';
import { Modal } from '../ui/Modal.js';
import { Pagina, Vacio } from '../ui/Pagina.js';
import { Ico } from '../ui/Iconos.js';
import { useT } from '../i18n/index.js';

export function Proveedores() {
  const t = useT();
  const proveedores = useLiveQuery(() => db.proveedores.toArray(), [], []);
  const compras = useLiveQuery(() => db.compras.toArray(), [], []);
  const puedeEditar = usePuede('recibir_compras');

  /**
   * «Nuevo» opens a sheet, the list as it was behind it: a form that opened in the page pushed the
   * list down (the owner, 2026-10-06: forms in a modal, not above the rest).
   */
  const [abierto, setAbierto] = useState(false);

  const activos = proveedores.filter((p) => p.activo).sort((a, b) => a.nombre.localeCompare(b.nombre, 'es'));

  return (
    <Pagina
      titulo={t('prov.titulo')}
      subtitulo={t('prov.activos', { n: activos.length })}
      acciones={
        puedeEditar && (
          <button
            type="button"
            className="btn-primario gap-1.5 px-4 text-sm"
            onClick={() => setAbierto(true)}
          >
            <Ico icono="nuevo" className="size-4" />
            {t('comun.nuevo')}
          </button>
        )
      }
    >
      {activos.length === 0 ? (
        <Vacio mensaje={t('prov.ninguno')} icono="proveedores" />
      ) : (
        <ul className="flex flex-col gap-2">
          {activos.map((p) => {
            const n = compras.filter((c) => c.proveedorId === p.id && !c.anulada && !esDeudaAnterior(c)).length;
            return (
              <li key={p.id} className="tarjeta">
                {/* The supplier opens on everything about them (the owner, 2026-10-16), as a client does. */}
                <Link
                  to="/proveedores/$proveedorId"
                  params={{ proveedorId: p.id }}
                  className="tarjeta-abrir flex items-center justify-between gap-4"
                  data-sin-icono="fila"
                  data-proveedor={p.id}
                >
                  <div className="min-w-0">
                    <p className="truncate font-medium">{p.nombre}</p>
                    {(p.telefono || p.contacto) && (
                      <p className="mt-0.5 truncate text-xs text-slate-500">
                        {[p.contacto, p.telefono].filter(Boolean).join(' · ')}
                      </p>
                    )}
                  </div>
                  <span className="shrink-0 text-xs text-slate-500">{t('prov.compras', { n })}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}

      {abierto && (
        <Modal titulo={t('prov.nuevo')} onCerrar={() => setAbierto(false)}>
          <FormularioProveedor onCreado={() => setAbierto(false)} />
        </Modal>
      )}
    </Pagina>
  );
}
